import { AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileManagerItem } from '../../../modules/file-manager/classes/file-manager.model';
import { MediaPlayer, MediaPlayerClass } from 'dashjs';
import { FileHelperService } from '../../../modules/file-manager/services/file-helper.service';

@Component({
    selector: 'app-video-viewer',
    templateUrl: './video-viewer.component.html',
    styleUrls: ['./video-viewer.component.scss'],
    standalone: false
})
export class VideoViewerComponent implements AfterViewInit, OnDestroy {
  @Input() fileManagerItem?: FileManagerItem;
  @Input() showHeader = true;
  @Input() autoplay = true;

  @ViewChild('videoPlayer') videoPlayer?: ElementRef<HTMLVideoElement>;

  protected player: MediaPlayerClass;

  get videoFile(): FileManagerItem | undefined {
    return this.fileManagerItem ?? this.dialogData?.fileManagerItem;
  }

  constructor(
    private fileHelperService: FileHelperService,
    @Inject(MatDialogRef) @Optional() private dialogRef: MatDialogRef<VideoViewerComponent> | null,
    @Inject(MAT_DIALOG_DATA) @Optional() private dialogData: { fileManagerItem: FileManagerItem } | null,
  ) {}

  ngAfterViewInit(): void {
    if (this.videoFile?.type === 'VIDEO' && this.videoPlayer) {
      this.player = MediaPlayer().create();
      const url = this.fileHelperService.getManifestUrl(this.videoFile.id);
      this.player.initialize(this.videoPlayer.nativeElement, url, this.autoplay);
    }
  }

  ngOnDestroy(): void {
    this.player?.reset();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }
}
